class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.cachedResults = {};
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('[data-predictive-search] .predictive-search__products');
    this.isOpen = false;
    this.setupEventListeners();
    this.clearButtonClick();
  }

  setupEventListeners() {
    const form = this.querySelector('form.search');
    form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {

    // var inputSwiper = document.querySelectorAll('.input-swiper');
    // if (inputSwiper) {
    //   inputSwiper.forEach(i => {
    //     i.style.display = 'none';
    //   }
    //   )
    // }
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }

    const searchTerm = this.getQuery();
    if (!searchTerm.length) {
      // this.close(true);
      return;
    }
    if (searchTerm.length != 0) {
      var inputSwiper = document.querySelectorAll('.input-swiper');
      if (inputSwiper) {
        inputSwiper.forEach(i => {
          i.style.visibility = 'hidden';
        }
        )
      }
    }
    if (window.innerWidth > 768) {
      var utils = document.querySelectorAll('.utils');
      utils.forEach(i => {
        i.style.display = 'none'
      })
    }
    this.setLiveRegionLoadingState();
    this.debounceTimer = setTimeout(() => {
      // const default_content = document.querySelectorAll('.predictive-search__default');
      // if (default_content.length > 0) {
      //   default_content.forEach(i => {
      //     i.style.display = 'none';
      //   });
      // }

      this.getSearchResults(searchTerm);
      // loadingstate.forEach(i => i.style.display = 'none')
      var filters = document.querySelectorAll('.filters');
      if (filters.length > 0) {
        filters.forEach(item => item.style.display = 'none');
      }
      // var item_List_bottom = document.querySelectorAll('.filter-item_List_bottom');
      // var filter_item_List = document.querySelectorAll('.recently_search');
      // if (item_List_bottom.length > 0) {
      //   item_List_bottom.forEach(item => item.style.display = 'none');
      // }
      // if (filter_item_List.length > 0) {
      //   filter_item_List.forEach(item => item.style.display = 'none');
      // }


      var recently_search = document.querySelectorAll('.Recently-Search');
      if (recently_search.length > 0) {
        recently_search.forEach(item => item.style.display = 'none');
      }

      var recentlySearch = JSON.parse(localStorage.getItem('Recently-Search') || '[]');
      recentlySearch.unshift(searchTerm);
      if (recentlySearch.length > 3) {
        recentlySearch.pop();
      }
      localStorage.setItem('Recently-Search', JSON.stringify(recentlySearch));
    }, 300);

  }

  onFormSubmit(event) {
    const hasSelectedItem = this.querySelector('[aria-selected="true"] a');
    const activeTab = this.querySelector('.fetch-tab.active');
    const searchType = activeTab?.getAttribute('data-search-tab')?.toLowerCase() || 'product';
    if (!this.getQuery().length) {
      event.preventDefault();
    } else if (hasSelectedItem) {
      event.preventDefault();
      hasSelectedItem.click();
    } else {
      event.preventDefault();
      if (searchType == 'product') {
        this.submitSearch('product');
      } else {
        this.submitSearch('article');
      }
    }

    // if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  submitSearch(type) {
    const searchTerm = this.getQuery();
    if (searchTerm.length) {
      window.location.href = `/search?q=${encodeURIComponent(searchTerm)}&type=${type}`;
    }
  }

  onFocus() {
    var inputSwiper = document.querySelectorAll('.input-swiper');
    if (inputSwiper.length > 0) {
      inputSwiper.forEach(i => {
        i.style.visibility = 'hidden';
      }
      )
    }
    const inputField = document.querySelectorAll('.search__input.field__input');
    if (inputField.length > 0) {
      inputField.forEach(i => {
        i.placeholder = '';
      }
      )
    }
    inputField.value = ''
    const searchTerm = this.getQuery();

    if (!searchTerm.length) return;

    if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(searchTerm);
    }
  }

  onFocusOut() {
    const searchTerm = this.getQuery();
    var inputSwiper = document.querySelectorAll('.input-swiper');
    const inputField = document.querySelectorAll('.search__input.field__input');
    if (inputSwiper.length > 0 && searchTerm.length == 0) {
      inputSwiper.forEach(i => {
        i.style.visibility = 'visible';
      })
      if (inputField.length > 0) {
        inputField.forEach(i => {
          i.placeholder = 'Search for ';
        }
        )
      }
      // const inputSwipers = new Swiper('.input-swiper', {
      //   direction: 'vertical',
      //   loop: true,
      //   autoplay: {
      //     delay: 5000,
      //     disableOnInteraction: false,
      //   },
      // })
    }
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();
    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up')
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (
      event.code === 'ArrowUp' ||
      event.code === 'ArrowDown'
    ) {
      event.preventDefault();
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');
    const allElements = this.querySelectorAll('li');
    let activeElement = this.querySelector('li');

    if (moveUp && !selectedElement) return;

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElement = selectedElement.nextElementSibling || allElements[0];
    } else if (moveUp) {
      activeElement = selectedElement.previousElementSibling || allElements[allElements.length - 1];
    }

    if (activeElement === selectedElement) return;

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.setLiveRegionText(activeElement.textContent);
    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedProduct = this.querySelector('[aria-selected="true"] a, [aria-selected="true"] button');

    if (selectedProduct) selectedProduct.click();
  }

  getSearchResults(searchTerm, type = 'product') {
    // const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    // const loadingstate = document.querySelectorAll('.predictive-search__loading-state')
    // loadingstate.forEach(i => i.style.display = 'flex')
    // if (this.cachedResults[queryKey]) {
    //   this.renderSearchResults(this.cachedResults[queryKey]);
    //   return;
    // }
    fetch(`search?q=${encodeURIComponent(searchTerm)}&options[prefix]=last&type=${type}&view=all&section_id=fetch-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then(async (text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-fetch-search').innerHTML;
        this.renderSearchResults(resultsMarkup);
        // this.cachedResults[queryKey] = resultsMarkup;
        if (this.querySelectorAll("[data-oke-star-rating]").length > 0 && window.okeWidgetApi) {
          this.querySelectorAll("[data-oke-star-rating]").forEach(el => window.okeWidgetApi.initWidget(el))
        }
        if (window.innerWidth > 768) {
          var utils = document.querySelectorAll('.utils');
          utils.forEach(i => {
            i.style.display = 'flex'
          })
          if (type == 'product') {

            const swiper = new Swiper('.search-product-card-list.Product', {
              slidesPerView: 5,
              spaceBetween: 8,
              navigation: {
                nextEl: '.swiper_icon_right',
                prevEl: '.swiper_icon_left',
                disabledClass: 'swiper-button-disabled'
              },
              loop: false,
              observer: true,
              observeParents: true,
              on: {
                init: function () {
                  // var left = document.querySelectorAll('.swiper_icon_left')
                  // left.forEach(i => {
                  //   i.classList.add('swiper-button-disabled')
                  // })
                  return
                },
                transitionEnd: function () {
                  return
                },
                resize: function () {
                  return
                }
              }
            });
          } else {
            const Blog_swiper = new Swiper('.search-product-card-list.Blog_swiper', {
              slidesPerView: 4,
              spaceBetween: 8,
              navigation: {
                nextEl: '.swiper_icon_right',
                prevEl: '.swiper_icon_left',
                disabledClass: 'swiper-button-disabled'
              },
              loop: false,
              observer: true,
              observeParents: true,
              on: {
                init: function () {
                  var left = document.querySelectorAll('.swiper_icon_left')
                  left.forEach(i => {
                    console.log(left)
                    i.classList.add('swiper-button-disabled')
                  })
                  return
                },
                transitionEnd: function () {
                  return
                },
                resize: function () {
                  return
                }
              }
            });
          }
        }

        const tabItems = document.querySelectorAll('.tab-item.fetch-tab');
        const contentSections = document.querySelectorAll('.search-product-card-list');
        var button = document.querySelectorAll('.utils .button');
        const Product_tab = document.querySelectorAll('.tab-item.Product');
        const Blog_tab = document.querySelectorAll('.tab-item.Blog');
        const Blog_box = document.querySelectorAll('.search-product-card-list.Blog')
        const Product_box = document.querySelectorAll('.search-product-card-list.Product')
        const switchover = document.querySelectorAll('.switchover');
        const loadingstate = document.querySelectorAll('.predictive-search__loading-state')
        button.forEach(i => {
          i.style.display = 'flex'
        })
        if (type == 'product') {
          await this.getSearchTitle(searchTerm)
        }

        if (type == 'product') {
          Product_tab.forEach(tab => {
            tab.classList.add('active')
            const count = tab.getAttribute('data-search-count')
            if (count <= 5) {
              switchover.forEach(i => {
                i.style.display = 'none'
              })
            } else {
              switchover.forEach(i => {
                i.style.display = 'flex'
              })
            }
            button.forEach(v => {
              v.innerText = 'view All ' + tab.innerText + 'S' + ' (' + tab.getAttribute('data-search-count') + ')';
              v.addEventListener('click', () => {
                window.location.href = `/search?q=${encodeURIComponent(searchTerm)}&type=product`;
              })
            })
          })
          Blog_box.forEach(i => {
            i.style.display = 'none';
          })
        } else {
          Blog_tab.forEach(tab => {
            tab.classList.add('active')
            button.forEach(v => {
              v.innerText = 'view All ' + tab.innerText + 'S' + ' (' + tab.getAttribute('data-search-count') + ')';
              v.addEventListener('click', () => {
                window.location.href = `/search?q=${encodeURIComponent(searchTerm)}&type=article`;
              })
            })
          })
          Blog_box.forEach(i => {
            i.style.display = 'flex';
          })
          Product_box.forEach(i => {
            i.style.display = 'none';
          })
        }

        tabItems.forEach(tab => {
          tab.addEventListener('click', (e) => {
            // loadingstate.forEach(i => i.style.display = 'none')
            this.setLiveRegionResults();
            const clickedTab = e.currentTarget;
            tabItems.forEach(item => item.classList.remove('active'));
            clickedTab.classList.add('active');
            const tabValue = clickedTab.getAttribute('data-search-tab');
            const url = clickedTab.getAttribute('data-search-url');
            const count = clickedTab.getAttribute('data-search-count')
            let num = 5
            if (tabValue == 'Blog') {
              num = 4
            }
            if (count <= num) {
              switchover.forEach(i => {
                i.style.display = 'none'
              })
            } else {
              switchover.forEach(i => {
                i.style.display = 'flex'
              })
            }
            button.forEach(item => {
              item.innerText = 'view All ' + clickedTab.innerText + 'S' + ' (' + clickedTab.getAttribute('data-search-count') + ')';
              item.addEventListener('click', () => {
                if (tabValue != 'Blog') {
                  window.location.href = `/search?q=${searchTerm}&type=product`
                } else {
                  window.location.href = `/search?q=${searchTerm}&type=article`
                }
              })
            })
            if (window.innerWidth < 768) {
              contentSections.forEach(section => {
                if (section.classList.contains(tabValue)) {
                  section.style.display = 'block';
                } else {
                  section.style.display = 'none';
                }
              });
            }
            if (clickedTab.getAttribute('data-search-tab') == 'Product') {
              this.getSearchResults(searchTerm, 'product')
            } else {
              this.getSearchResults(searchTerm, 'article')
            }
          })
        })
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  getSearchTitle(searchTerm, type = 'product') {
    if (!searchTerm) {
      return
    }
    fetch(`/search/suggest.json?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=${type}&resources[limit]=6&resources[options][fields]=title`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.json();
      }).then((res) => {
        if (type == 'product') {
          type = 'products'
        } else {
          type = 'articles'
        }
        var titles = res.resources.results[type].map(product => product.title) || []
        var related_keywords = document.querySelectorAll('.related_keywords')
        if (related_keywords.length > 0) {
          related_keywords.forEach(t => {
            t.style.display = 'flex'
            while (t.firstChild) {
              t.removeChild(t.firstChild);
            }
            // related_keywords.innerHTML = ''
            if (titles.length > 0 && t) {
              for (let i = 0; i < titles.length; i++) {
                const keywords = document.createElement('div');
                keywords.className = 'related_keyword';
                keywords.innerText = titles[i];
                t.appendChild(keywords);
                keywords.addEventListener('click', () => {
                  window.location.href = `/search?type=product&q=${keywords.innerText.trim()}`
                })
              }
            }else {
                t.style.display = 'none'
            }

          })
        } 
      }).catch((error) => {
        this.close();
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);

    this.setLiveRegionResults();
    this.open();
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight = window.innerHeight - document.querySelector('.shopify-section-header').getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }

    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false
    this.predictiveSearchResults.removeAttribute('style');

    this.isOpen = false;
  }

  clearButtonClick() {
    const clearButton = document.querySelectorAll('.field__label');
    const inputField = document.querySelectorAll('.search__input.field__input');
    const default_content = document.querySelectorAll('.predictive-search__default');
    const products = document.querySelectorAll('.predictive-search__products');
    const default_show = document.querySelectorAll('.default_show');
    const contentSectionsdefault = document.querySelectorAll('.search-product-card-list-default');
    const contentSections = document.querySelectorAll('.search-product-card-list');
    const filter_item_List_bottom = document.querySelectorAll('.filter-item_List_bottom');
    const recently_search = document.querySelectorAll('.Recently-Search');
    var button = document.querySelectorAll('.utils .button');
    const tabItems = document.querySelectorAll('.tab-item');
    const switchover = document.querySelectorAll('.switchover');
    var filters = document.querySelectorAll('.filters');
    var inputSwiper = document.querySelectorAll('.input-swiper');
    var related_keywords = document.querySelectorAll('.related_keywords')
    clearButton.forEach(item => {
      item.addEventListener('click', async () => {
        event.preventDefault();
        inputField.forEach(i => {
          i.value = '';
          i.placeholder = 'Search for ';
        })
        related_keywords.forEach(t => {
          t.style.display = 'none'
        })
        // const searchEle = this.closest(".template-search");
        // if (searchEle) {
        //   console.log(searchEle.dataset.searchUrl)
        //   window.location.href = searchEle.dataset.searchUrl;
        //   return;
        // }
        button.forEach(i => {
          i.style.display = 'flex'
        })
        inputSwiper.forEach(i => {
          i.style.visibility = 'visible'
        })
        tabItems.forEach(i => {
          i.classList.remove('active')
        })
        products.forEach(i => {
          i.innerHTML = ''
        })
        default_content.forEach(i => {
          i.style.display = 'block'
        })
        contentSections.forEach(d => {
          d.style.display = 'none';
        })
        switchover.forEach(i => {
          i.style.display = 'flex'
        })
        default_show.forEach(c => {
          c.classList.add('active')
          button.forEach(v => {
            v.innerText = 'view All ' + c.innerText + 'S' + ' (' + c.getAttribute('data-search-count') + ')';
            v.addEventListener('click', () => {
              window.location.href = c.getAttribute('data-search-url');
            })
          })
        })
        contentSectionsdefault.forEach(section => {
          section.style.display = 'block';
        });
        if (filters.length > 0) {
          filters.forEach(item => item.style.display = 'flex');
        }
        if (filter_item_List_bottom.length > 0) {
          filter_item_List_bottom.forEach(item => item.style.display = 'flex');
        }
        if (recently_search.length > 0) {
          recently_search.forEach(item => item.style.display = 'flex');
        }

        this.predictiveSearchResults.innerHTML = ''
      });
    })
  }
}

customElements.define('predictive-search', PredictiveSearch);



